export const { SITE_BASE_URL } = process.env;
export const BASE_URI_LP = `${SITE_BASE_URL}/lp`;

export const LP_WILDFIRE = `${BASE_URI_LP}/shopping-rewards`;
export const BOA_2024 = `${SITE_BASE_URL}/l/awards`;
export const NW_PLUS = `${SITE_BASE_URL}/lp/nerdwallet-plus-main`;
export const NW_TAXES = `${SITE_BASE_URL}/p/file-taxes-online`;
